import Vue from 'vue'
require('intersection-observer')

Vue.directive('intersected', {
  bind: function (el, binding, vnode) {
    el.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry && entry.isIntersecting) {
          vnode.context[binding.expression](el, entry, el.observer)
        }
      })
    })
    el.observer.observe(el)
  },
  unbind: function (el) {
    el.observer.disconnect()
  }
})
